import { render, staticRenderFns } from "./MaskCreator.vue?vue&type=template&id=4bc4dd4c&scoped=true&"
import script from "./MaskCreator.vue?vue&type=script&lang=js&"
export * from "./MaskCreator.vue?vue&type=script&lang=js&"
import style0 from "./MaskCreator.vue?vue&type=style&index=0&id=4bc4dd4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4dd4c",
  null
  
)

export default component.exports